import { FieldContent, FieldDescription, FieldLabel } from "@/components/ui/baseUi/field"
import {
  FieldField,
  FieldMessage,
  FormCheckbox,
  FormCountrySelect,
  FormGalleryPicker,
  FormImagePicker,
  FormInput,
  FormInputGroupInput,
  FormNumberCursor,
  FormNumberInput,
  FormPassword,
  FormPhoneInput,
  FormPriceInput,
  FormSearchUser,
  FormSelect,
  FormSwitch,
  FormSwitchInline,
  FormTextarea,
} from "@/components/ui/forms/components"
import { createFormHook, createFormHookContexts } from "@tanstack/react-form"

export const { fieldContext, formContext, useFieldContext } = createFormHookContexts()

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Input: FormInput,
    InputGroupInput: FormInputGroupInput,
    NumberCursor: FormNumberCursor,
    NumberInput: FormNumberInput,
    Password: FormPassword,
    SearchUser: FormSearchUser,
    Select: FormSelect,
    Textarea: FormTextarea,
    Checkbox: FormCheckbox,
    Switch: FormSwitch,
    SwitchInline: FormSwitchInline,
    PriceInput: FormPriceInput,
    Label: FieldLabel,
    Description: FieldDescription,
    Message: FieldMessage,
    Field: FieldField,
    Content: FieldContent,
    PhoneInput: FormPhoneInput,
    CountrySelect: FormCountrySelect,
    GalleryPicker: FormGalleryPicker,
    ImagePicker: FormImagePicker,
  },
  formComponents: {},
})
